import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-demo-dropdown',
  templateUrl: './demo-dropdown.component.html',
  styleUrls: ['./demo-dropdown.component.less']
})
export class DemoDropdownComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
